import React, { useState, useEffect } from 'react';
import "../../asset/css/wallet.css";
import Topbar from '../../component/Topbar';
import SideMenu from '../../component/SideMenu';
import RequestInvoice from './RequestInvoice';
import AddFund from './AddFund';
import WithdrawFund from './WidthrawFund';
import { baseurl } from '../../baseurl';
import axios from 'axios';
import Swal from 'sweetalert2';

const Wallet = () => {
    // API Data States
    const [walletData, setWalletData] = useState({
        balance: "0.00",
        updated_at: null,
        transactions: []
    });
    const [loading, setLoading] = useState(true);

    // Modal Visibility States
    const [showAddFunds, setShowAddFunds] = useState(false);
    const [showWithdraw, setShowWithdraw] = useState(false);
    const [showInvoice, setShowInvoice] = useState(false);

    // Filter States
    const [filter, setFilter] = useState('all');

    // Frontend Pagination State
    const [visibleCount, setVisibleCount] = useState(10);

    // Fetch Wallet Data
    useEffect(() => {
        const fetchWalletInfo = async () => {
            const userToken = localStorage.getItem('userToken');
            if (!userToken) {
                setLoading(false);
                return;
            }

            try {
                const res = await axios.get(`${baseurl}getUserCreditData`, {
                    headers: { Authorization: `Bearer ${userToken}` }
                });

                if (res.data.success) {
                    setWalletData({
                        balance: res.data.data.wallet.balance,
                        updated_at: res.data.data.wallet.updated_at,
                        transactions: res.data.data.transactions
                    });
                }
            } catch (err) {
                console.error("Fetch Wallet Error:", err);
            } finally {
                // Keep loading for a split second longer for smooth skeleton transition
                setTimeout(() => setLoading(false), 500);
            }
        };

        fetchWalletInfo();
    }, []);

    // Filter Logic
    const filteredTransactions = walletData.transactions.filter(item => {
        if (filter === 'all') return true;
        if (filter === 'credits') return parseFloat(item.amount) > 0;
        if (filter === 'debits') return parseFloat(item.amount) < 0;

        if (filter === 'month') {
            const transactionDate = new Date(item.created_at);
            const now = new Date();
            return (
                transactionDate.getMonth() === now.getMonth() &&
                transactionDate.getFullYear() === now.getFullYear()
            );
        }
        return true;
    });

    const displayedTransactions = filteredTransactions.slice(0, visibleCount);

    useEffect(() => {
        setVisibleCount(10);
    }, [filter]);

    const handleLoadMore = () => {
        setVisibleCount(prev => prev + 10);
    };

    // Body Scroll Lock
    useEffect(() => {
        const isAnyModalOpen = showAddFunds || showWithdraw || showInvoice;
        document.body.style.overflow = isAnyModalOpen ? 'hidden' : 'auto';
    }, [showAddFunds, showWithdraw, showInvoice]);

    // --- SKELETON LOADER COMPONENT ---
    const SkeletonRow = () => (
        <div className="table-row d-flex align-items-center p-3 border-bottom bg-white skeleton-wrapper">
            <div style={{ width: '5%' }}><div className="skeleton skeleton-text" style={{ width: '20px' }}></div></div>
            <div style={{ width: '10%' }}><div className="skeleton skeleton-circle"></div></div>
            <div style={{ width: '20%' }}><div className="skeleton skeleton-text" style={{ width: '60px' }}></div></div>
            <div style={{ width: '45%' }}>
                <div className="skeleton skeleton-text" style={{ width: '150px', marginBottom: '8px' }}></div>
                <div className="skeleton skeleton-text" style={{ width: '80px' }}></div>
            </div>
            <div style={{ width: '20%' }} className="text-end ml-auto">
                <div className="skeleton skeleton-text ms-auto" style={{ width: '70px' }}></div>
            </div>
        </div>
    );

    return (
        <div className="app-container">
            <Topbar />
            <div className="main-wrapper" style={{ background: '#F4F7FE', display: 'flex' }}>
                <SideMenu />

                <div className="profile-content-container p-3" id="mainContent" style={{ flex: 1, overflow: 'auto' }}>
                    <div className="page-header">
                       <div className='page-title-section'>
                                <h1>My Credit</h1>
                                <p className='page-subtitle' >Manage your Credit and transaction history</p>
                            </div>

                        {/* <div className="page-actions">
                            <button className="btn-action btn-secondary">
                                <i className="fas fa-history"></i> View Statements
                            </button>
                            <RequestInvoice />
                        </div> */}
                    </div>

                    <div className="wallet-balance-card">
                        <div className="balance-header">
                            <div>
                                <div className="balance-title">Credit Balance</div>
                                <div className="balance-amount">
                                    {loading ? <span className="skeleton skeleton-text" style={{ width: '100px', height: '30px', display: 'inline-block' }}></span> : `${walletData.balance} Credits`}
                                </div>
                                <div className="balance-update">
                                    <i className="fas fa-sync-alt"></i> Last updated: {walletData.updated_at ? new Date(walletData.updated_at).toLocaleDateString() : 'N/A'}
                                </div>
                            </div>
                        </div>
                        <div className="wallet-actions">
                            <AddFund />
                        </div>
                    </div>

                    <div className="section-header">
                        <div className="section-title"><i className="fas fa-history"></i> Transaction History</div>
                        <div className="filter-options">
                            {['all', 'credits', 'debits', 'month'].map((opt) => (
                                <button 
                                    key={opt} 
                                    className={`filter-btn ${filter === opt ? 'active' : ''}`} 
                                    onClick={() => setFilter(opt)}
                                >
                                    {opt === 'month' ? 'This Month' : opt.charAt(0).toUpperCase() + opt.slice(1)}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="transactions-table">
                        <div className="table-header d-flex text-dark p-3 border-bottom bg-light">
                            <div style={{ width: '5%' }}>#</div>
                            <div style={{ width: '10%' }}>Type</div>
                            <div style={{ width: '20%' }}>Credit(s)</div>
                            <div style={{ width: '45%' }}>Description</div>
                            <div style={{ width: '20%' }} className="text-center">Date</div>
                        </div>

                        {loading ? (
                            // Render 5 skeleton rows while loading
                            <>
                                <SkeletonRow />
                                <SkeletonRow />
                                <SkeletonRow />
                                <SkeletonRow />
                                <SkeletonRow />
                            </>
                        ) : displayedTransactions.length > 0 ? (
                            <>
                                {displayedTransactions.map((tx, index) => {
                                    const integerAmount = tx.amount;
                                    const isCredit = parseFloat(tx.amount) >= 0;

                                    return (
                                        <div className="table-row transaction-item d-flex align-items-center p-3 border-bottom bg-white" key={tx.id}>
                                            <div style={{ width: '5%' }} className="text-muted">{index + 1}</div>
                                            <div style={{ width: '10%' }}>
                                                <div className={`transaction-type ${isCredit ? 'type-credit' : 'type-debit'}`}>
                                                    <i className={`fas ${isCredit ? 'fa-arrow-down' : 'fa-arrow-up'}`}></i>
                                                </div>
                                            </div>
                                            <div style={{ width: '20%' }}>
                                                <div className={`transaction-amount fw-bold ${isCredit ? 'amount-credit' : 'amount-debit'}`}>
                                                    {isCredit ? `+${integerAmount}` : integerAmount}
                                                </div>
                                            </div>
                                            <div style={{ width: '45%' }}>
                                                <div className="transaction-details">
                                                    <div className="transaction-title fw-bold text-dark">{tx.description}</div>
                                                    <div className="text-muted small" style={{ fontSize: '10px', textTransform: 'uppercase' }}>
                                                        {tx.transaction_type}
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ width: '20%' }} className="text-center">
                                                <div className="transaction-date " style={{ fontSize: '12px' }}>
                                                    {new Date(tx.created_at).toLocaleDateString()}
                                                </div>
                                                <div>
                                                    <span className='walletbg'>Completed</span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                                {visibleCount < filteredTransactions.length && (
                                    <div className="p-3 text-center bg-white border-top">
                                        <button 
                                            className="btn btn-outline-danger btn-sm px-4" 
                                            onClick={handleLoadMore}
                                            style={{ borderRadius: '20px', fontWeight: '600' }}
                                        >
                                            Load More
                                        </button>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="p-5 text-center text-muted bg-white">
                                <i className="fas fa-folder-open d-block mb-2" style={{ fontSize: '24px' }}></i>
                                No transactions found for this filter.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Wallet;